// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ArrowUpRightIcon = /* @__PURE__ */ createIcon(
  'arrow-up-right',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M18 17a1 1 0 1 1-2 0V9.414l-8.293 8.293a1 1 0 1 1-1.414-1.414L14.586 8H7a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1z',
      },
    ],
  ]
);
